export default __webpack_public_path__ + "static/media/girl10.4d7fddcb.jpg";